__webpack_require__.p = "https://static.meandu.app/app/front-end-web/deploy-9660/_next/";